import { useEffect, useRef } from "react";
import { motion } from "framer-motion";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

// Generic section wrapper with scroll-triggered fade & y reveal
export default function Section({
  id,
  children,
  className = "",
  bg = "",
  noPad = false,
  testId,
}) {
  const ref = useRef(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const isMobile = window.innerWidth < 768;
    const ctx = gsap.context(() => {
      const targets = el.querySelectorAll("[data-reveal]");
      if (!targets.length) return;
      gsap.from(targets, {
        opacity: 0,
        y: isMobile ? 14 : 24,
        duration: 0.55,
        ease: "power3.out",
        stagger: 0.06,
        scrollTrigger: {
          trigger: el,
          start: "top 86%",
          toggleActions: "play none none none",
        },
      });
    }, el);
    return () => ctx.revert();
  }, []);

  return (
    <section
      id={id}
      ref={ref}
      data-testid={testId}
      className={`relative ${noPad ? "" : "py-20 md:py-28 lg:py-32"} ${className}`}
    >
      {bg && <div className="absolute inset-0 -z-10">{bg}</div>}
      {children}
    </section>
  );
}

export const RevealItem = ({ children, className = "", as: Tag = "div", ...rest }) => (
  <Tag data-reveal className={className} {...rest}>
    {children}
  </Tag>
);

export const PageEnter = ({ children }) => (
  <motion.div
    initial={{ opacity: 0, y: 12 }}
    animate={{ opacity: 1, y: 0, transition: { duration: 0.5, ease: "easeOut" } }}
    exit={{ opacity: 0, transition: { duration: 0.25 } }}
  >
    {children}
  </motion.div>
);
